/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  app.AuthRouter = Backbone.Router.extend({
    routes: {
      'signup': 'loadSignup',
      'login': 'loadLogin'
    },
    
    /**
     * Форма регистрации
     */
    loadSignup: function () {
      this.trigger('clickSignup');
    },
    
    /**
     * Форма авторизации
     */
    loadLogin: function () {
      this.trigger('clickLogin');
    }
  });
})();


}.call(window));